import { VariantTemplate } from "./isVariantTemplate";

/**
 * Finds a duplicate variant using patch-set equality, independent of patch order.
 *
 * @param templates - Named definitions in the current TLF
 * @param patchNames - Patch selection to compare with existing definitions
 * @param variantName - Name being added or updated, excluding its current definition
 * @returns The conflicting definition's name, or undefined when the selection is unique
 */
export const getDuplicateVariantName = (
  templates: VariantTemplate[],
  patchNames: string[],
  variantName: string,
): string | undefined => {
  const selected = new Set(patchNames);
  return templates.find((template) => {
    const patches = new Set(template.variantPatches);
    return (
      template.name !== variantName &&
      patches.size === selected.size &&
      [...patches].every((patch) => selected.has(patch))
    );
  })?.name;
};
